import { getDay, isAfter, isBefore, startOfDay } from "date-fns"
import type { UserEvent } from "@/services/api/cronos/user/events/get-all"

export const isOutOfAllowedRange = (
  start: Date,
  end: Date,
  minDate: Date,
  maxDate: Date,
): boolean => {
  const startDay = startOfDay(start)
  const endDay = startOfDay(end)
  const minDay = startOfDay(minDate)
  const maxDay = startOfDay(maxDate)

  return isBefore(startDay, minDay) || isAfter(endDay, maxDay)
}

export const isMovedToDifferentDay = (event: UserEvent, newStart: Date, newEnd: Date): boolean => {
  const newStartDay = getDay(newStart)
  const newEndDay = getDay(newEnd)
  return newStartDay !== event.day || newEndDay !== event.day
}

export const hasRecurringEventOnSameDay = (
  event: UserEvent,
  newStart: Date,
  newEnd: Date,
): boolean => {
  const newStartDay = getDay(newStart)
  const newEndDay = getDay(newEnd)
  return event.parent.days.includes(newStartDay) || event.parent.days.includes(newEndDay)
}
